import { render, staticRenderFns } from "./legacy.vue?vue&type=template&id=74b58c0a&scoped=true&"
import script from "./legacy.vue?vue&type=script&lang=js&"
export * from "./legacy.vue?vue&type=script&lang=js&"
import style0 from "./legacy.vue?vue&type=style&index=0&id=74b58c0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b58c0a",
  null
  
)

export default component.exports